import type { IDigestateJobScheduleForm } from '@/interfaces'
import Base from '../Base'

class DigestateJobScheduleForm extends Base implements IDigestateJobScheduleForm {
  scheduledDate: string
  employee: string
  vehicle: string
  description: string

  constructor(jobData?: any) {
    super(jobData)
    this.scheduledDate = jobData?.scheduledDate ?? null
    this.employee = jobData?.employee ?? null
    this.vehicle = jobData?.vehicle ?? null
    this.description = jobData?.description ?? null
  }
}

export default DigestateJobScheduleForm
